import { KeyboardEvent } from "react";
import { Plus, Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface TypeAddInputProps {
  value: string;
  onChange: (v: string) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  onAdd: () => void;
  placeholder: string;
  hint?: string;
  className?: string;
}

/** Clearly visible "type your own" box with an Add button, used on targeting steps. */
export function TypeAddInput({ value, onChange, onKeyDown, onAdd, placeholder, hint = "Type your own and press Enter or Add", className }: TypeAddInputProps) {
  return (
    <div className={cn("w-full max-w-md space-y-1.5", className)}>
      <div className="flex items-center gap-2 rounded-lg border-2 border-primary/30 bg-background pl-3 pr-1 shadow-sm transition-colors focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20">
        <Pencil className="h-4 w-4 shrink-0 text-primary" />
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={onKeyDown}
          onBlur={onAdd}
          placeholder={placeholder}
          className="h-10 flex-1 min-w-0 bg-transparent text-sm text-foreground outline-none placeholder:text-muted-foreground"
        />
        <Button
          type="button"
          size="sm"
          variant={value.trim() ? "default" : "secondary"}
          className="h-8 gap-1"
          onMouseDown={(e) => e.preventDefault()}
          onClick={onAdd}
        >
          <Plus className="h-3.5 w-3.5" /> Add
        </Button>
      </div>
      <p className="text-xs text-muted-foreground">{hint}</p>
    </div>
  );
}
